<template>
<v-card tile flat height="100%" >
  <v-overlay :value='overlay' absolute opacity='0.2' >
    <center>
      <v-progress-circular :size=76 indeterminate color='amber' class='mb-5' /><br/>
      <span class='subtitle-1'>Saving</span>
    </center>
  </v-overlay>
  <v-progress-linear v-if='loading' indeterminate :height='2' class='ma-0 pa-0' />
  <slot name='top' ></slot>
  <slot >

  <v-card-title
    v-if='title'
    class='subtitle-1 overline  white--text justify-center' v-text='title' />
  </slot>

  <div v-show='showHelpInformation' >
  <slot name='help-card' >
    <help-card
      v-bind='help'
      @done='helpTextRead = true' >
    </help-card>
  </slot>
  </div>
  <v-stepper tile
    v-show='!showHelpInformation'
    v-model='step' class='fill-height elevation-0' >
    <v-stepper-items class='ma-1 ma-sm-16'>
      <v-stepper-content
        v-for='(s, index) in steps' :key='s.id'
        :step="index + 1" class='pa-2' >
        <slot :name="`item-${s.id}`" >
          <v-card flat >
            <v-card-actions >
              <v-btn
                @click='goBack(s)'
                :disabled='s.allowback===false'
                text >
                <v-icon small class='mr-2' >mdi-arrow-left</v-icon>
                Back
              </v-btn>

              <v-spacer />
                <slot name='list-preview' >
                </slot>
              <v-spacer/>

              <v-btn
                :disabled='s.skipable!==true'
                @click='step++' text >skip step</v-btn>
              <v-btn outlined color='primary'
                :disabled='!canNext'
                @click='proceed(s)' >
                Next
                <v-icon small class='ml-2' >mdi-arrow-right</v-icon>
              </v-btn>
              <!-- <p class='caption grey--text'>(or press enter)</p> -->
            </v-card-actions>
            <v-divider class='mb-5' />
            <v-card-text class='pa-0' >
              <slot :name="`component-${s.id}`" >
                <v-component
                  v-if='s.component'
                  :is='s.component'
                  :label='s.title'
                  :hint='s.hint'
                  v-model='obj[s.id]'
                  v-bind='s.attrs'
                  v-on='s.events'
                  @close="$emit('close')" />

                <template v-else >

                  <v-textarea filled persistent-hint
                    v-if='s.vcomponent==="textarea"'
                    v-model='obj[s.id]'
                    v-bind='step.attrs'
                    v-on='s.events'
                    :id='s.id'
                    :label='s.title'
                    :hint='s.hint' >
                  </v-textarea>

                  <v-text-field v-else filled persistent-hint autofocus
                    @keypress.enter="proceed(s)"
                    v-model='obj[s.id]'
                    v-bind='step.attrs'
                    v-on='s.events'
                    class='xl '
                    :id='s.id'
                    :label='s.title'
                    :hint='s.hint' />
                </template>
              </slot>
              <slot :name="`component-${s.id}-after`" ></slot>
            </v-card-text>
            <slot name="actions" >
            </slot>
          </v-card>
        </slot>
      </v-stepper-content>
    </v-stepper-items>

    <v-stepper-header flat
      v-if='withSteps'
      class='grey lighten-4'
      style='position:fixed;bottom:0px;left:0px;right:0px;z-index:1000;border-top:solid 1px black;' >
      <template v-for='(s, index) in steps' >
        <v-stepper-step
          :key='s.id'
          :step="index + 1"
          :color="getStepColor(index)"
          :editable="step > index+1"
          :complete="step > index+1"
          edit-icon='mdi-check' >
        </v-stepper-step>
        <v-divider v-if='index+1 < steps.length' :key='`div-${s.id}`' />
      </template>
    </v-stepper-header>
  </v-stepper>
  <v-btn fab top right small fixed
    v-if='withClose'
    @click='$emit("close")'
    color='info' >
    <v-icon >mdi-close</v-icon>
  </v-btn>
</v-card>
</template>
<script>
import Vue from 'vue'
import HelpCard from '@/components/actions/wizards/HelpCard.vue'

export default {
  name: 'CarouselLayout',
  components: { HelpCard },
  props: {
    title: { type: String },
    value: { type: Object },
    activeStep: { type: Number, default: 0 },
    success: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    isValid: { type: Boolean, default: false },
    withClose: { type: Boolean, default: false },
    withSteps: { type: Boolean, default: false },
    steps: { type: Array, default: () => { return [] } },
    withHelpText: { type: Boolean, default: false },
    help: { type: Object, default: () => { return [] } }
  },
  data () {
    return {
      step: 0,
      helpTextRead: false,
      obj: {}
    }
  },
  mounted () {
    this.steps.forEach((step) => {
      Vue.set(this.obj, step.id, step.default)
    })
    this.setFocus()
  },
  methods: {
    setFocus () {
      let s = this.steps[this.step]
      if (s) {
        window.setTimeout(() => {
          let el = document.getElementById(s.id)
          if (el) { el.focus() }
        }, 300)
      }
    },
    goBack (step) {
      if (step.onback) {
        return step.onback(step, this.obj)
      } else {
        this.step--
      }
    },
    proceed (step) {
      if (step && step.validator && !step.validator(step, this.obj)) { return false }
      if (step.next) {
        return step.next(step, this.obj)
      } else {
        this.step++
      }
    },
    arrowClicked (newStep) {
      return newStep
    },
    getStepColor (index) {
      if (this.step === index + 1) { return 'info' }
      if (this.step > index) { return 'success' }
      return 'grey'
    }
  },
  watch: {
    step () {
      this.setFocus()
      this.$emit('update:activeStep', this.step)
    },
    value () {
      this.obj = this.value
    },
    obj: {
      deep: true,
      handler () {
        this.$emit('input', this.obj)
      }
    },
    activeStep: {
      immediate: true,
      handler () {
        this.step = this.activeStep
      }
    }
  },
  computed: {
    showHelpInformation () {
      if (this.withHelpText && !this.helpTextRead && this.help) {
        return true
      }
      return false
    },
    cardcolor () {
      return 'grey'
    },
    fabcolor () {
      return 'info'
    },
    canNext () {
      let step = this.steps[this.step - 1]
      if (step && step.validator) {
        return step.validator(step, this.obj)
      }
      return true
    }
  }
}
</script>
